import script from "./FatigueManagementPlanCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./FatigueManagementPlanCompleted.vue?vue&type=script&setup=true&lang=js"

import "./FatigueManagementPlanCompleted.vue?vue&type=style&index=0&id=0036ee63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0036ee63"]])

export default __exports__